import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex, Image, Text } from '@mantine/core';

import { FileUploadIcon } from 'icons';
import type { OrganisationType } from 'types';

import { LogoSettingsModal } from './LogoSettingsModal';

type Props = {
  organisation: OrganisationType;
};

export const LogoSettings = ({ organisation }: Props) => {
  const [opened, setOpened] = useState(false);

  const { t } = useTranslation('organisations');

  const {
    isAdministrator,
    details: { logoUrl },
  } = organisation;

  return (
    <Flex gap="xl">
      <Box
        sx={theme => ({
          flex: `0 0 ${theme.other.spacing(10)}px`,
          height: theme.other.spacing(10),
          border: `1px solid ${theme.colors.gray[2]}`,
          borderRadius: theme.radius.sm,
          overflow: 'hidden',
          cursor: isAdministrator ? 'pointer' : 'default',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#f7f8ff',
        })}
        onClick={() => isAdministrator && setOpened(true)}
      >
        {logoUrl ? (
          <Image src={logoUrl} />
        ) : (
          <FileUploadIcon
            sx={{ position: 'relative', top: 3, left: 3 }}
            color="blue.6"
          />
        )}
      </Box>
      <LogoSettingsModal
        organisation={organisation}
        opened={opened}
        onClose={() => setOpened(false)}
      />
      <Box>
        <Text
          sx={theme => ({
            fontSize: 15,
            fontWeight: 'bold',
            marginBottom: theme.other.spacing(1),
          })}
        >
          {t('organisationView.details.profile.logo.title')}
        </Text>
        <Text sx={theme => ({ fontSize: 13, color: theme.colors.gray[6] })}>
          {isAdministrator
            ? t('organisationView.details.profile.logo.description.default')
            : t('organisationView.details.profile.logo.description.adminOnly')}
        </Text>
      </Box>
    </Flex>
  );
};
